import React, {useContext, useReducer, createContext} from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    IconButton,
    Typography,
  } from '@material-ui/core';
import { Close } from '@material-ui/icons';

const ConfirmContext = createContext()

const SHOW_CONFIRM = 'SHOW_CONFIRM'
const HIDE_CONFIRM = 'HIDE_CONFIRM'

const initialState = {
  show: false,
  text: ''
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_CONFIRM:
        return {
            show: true,
            text: action.payload.text
        };
    case HIDE_CONFIRM:
        return initialState;
    default:
        return initialState;
  }
}

export const ConfirmProvider = ({children}) => {
  const [state, dispatch]= useReducer(reducer, initialState)
  return (
    <ConfirmContext.Provider value={[state, dispatch]}>
      {children}
    </ConfirmContext.Provider>
  )
}

let resolveCallback;

export const useConfirm = () => {
  const [confirmState, dispatch]= useContext(ConfirmContext)


  const onConfirm = () => {
    closeConfirm()
    resolveCallback(true)
  }

  const onCancel = () => {
    closeConfirm()
    resolveCallback(false)
  }

  const confirm = (text) => {
    dispatch({type:SHOW_CONFIRM,payload:{text}})

    return new Promise((res, rej) => {
      resolveCallback= res;
    })
  }

  const closeConfirm= () => {
    dispatch({type:HIDE_CONFIRM})
  }

  return { confirm, onConfirm, onCancel, confirmState }
}

const ConfirmDialog = () => {
    const { onConfirm, onCancel, confirmState} = useConfirm()

    return (
        <Dialog open={confirmState.show} maxWidth="sm" fullWidth>
          <DialogTitle>Let op!</DialogTitle>
          <Box position="absolute" top={0} right={0}>
            <IconButton onClick={onCancel}>
              <Close />
            </IconButton>
          </Box>
          <DialogContent>
            <Typography>{confirmState.text}</Typography>
          </DialogContent>
          <DialogActions>
            <Button color="secondary" variant="contained" onClick={onConfirm}>
              Ok
            </Button>
            <Button variant="contained" onClick={onCancel}>
              Annuleren
            </Button>
          </DialogActions>
        </Dialog>
    )
  };
  
  export default ConfirmDialog;
  